import { Injectable } from '@angular/core';
import { environment } from './environment/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public apiUrl: string;
  public headers = {};
  constructor() {
    // Use environment.apiUrl for localhost, otherwise use window.location.origin
    if (window.location.hostname === 'localhost') {
      this.apiUrl = environment.apiUrl;
    } else {
      this.apiUrl = window.location.origin;
    }
  }
}
